import { render, staticRenderFns } from "./OrganizationHierarchy.vue?vue&type=template&id=6faa26fc&scoped=true"
import script from "./OrganizationHierarchy.vue?vue&type=script&lang=js"
export * from "./OrganizationHierarchy.vue?vue&type=script&lang=js"
import style0 from "./OrganizationHierarchy.vue?vue&type=style&index=0&id=6faa26fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa26fc",
  null
  
)

export default component.exports